<template>
  <div class="invoices">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Reply Buttons</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Reply Buttons</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <a
                  ref="formBc"
                  class="btn add-btn"
                  @click="showBroadcast(true)"
                  href="#"
                  data-toggle="modal"
                  data-target="#add_form"
                >
                  <i class="fa fa-tags"></i> Add Buttons
                </a>
                <a
                  v-show="false"
                  ref="formBcEdit"
                  class="btn add-btn"
                  @click="showBroadcast(false)"
                  href="#"
                  data-toggle="modal"
                  data-target="#add_form"
                >
                  <i class="fa fa-whatsapp"></i> Edit
                </a>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <!-- Search Filter -->
          <div class="row filter-row">
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <input
                  class="form-control floating"
                  v-model="serverParams.columnFilters.button_title"
                  type="text"
                />
                <label class="focus-label">Title</label>
              </div>
            </div>

            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <input
                  class="form-control floating"
                  v-model="serverParams.columnFilters.button_text"
                  type="text"
                />
                <label class="focus-label">Button Text</label>
              </div>
            </div>

            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <input
                  class="form-control floating"
                  v-model="serverParams.columnFilters.button_response"
                  type="text"
                />
                <label class="focus-label">Respond</label>
              </div>
            </div>

            <div class="col-sm-6 col-md-3">
              <a
                href="javascript:void(0)"
                @click.prevent="searchData"
                class="btn btn-success btn-block"
              >Search</a>
            </div>
          </div>
          <div class="row filter-row" v-if="selectedTable.length">
            <div class="col-sm-6 col-md-2">
              <div class="form-group">
                <button
                  :disabled="isLoading"
                  @click.prevent="actionDelete"
                  class="btn btn-danger btn-block"
                >
                  <i class="la la-trash"></i> Remove
                </button>
              </div>
            </div>
            <div class="col-sm-6 col-md-10">
              <div class="text-right">
                <!-- <button class="btn btn-success btn-block">Scrape</button>-->
                <a @click.prevent="hideActions" class="btn btn-xs">
                  <i class="fa fa-close"></i> Close
                </a>
              </div>
            </div>
          </div>
          <!-- /Search Filter -->
          <div class="row">
            <div class="col-md-12">
              <!-- {{currentDateTimeUnix()}} -->
              <div class="table-responsive">
                <table class="table table-striped custom-table mb-0">
                  <thead>
                    <tr>
                      <th>
                        <div class="checkbox">
                          <label>
                            <input type="checkbox" v-model="selectAllTable" />
                          </label>
                        </div>
                      </th>
                      <th>Title</th>
                      <th>Button Text</th>
                      <th style="width:200px;">Respond</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="loading">
                      <tr>
                        <td colspan="5">
                          <Skeleton :count="1" />
                        </td>
                      </tr>
                    </template>
                    <template v-if="rows.length">
                      <tr v-for="(row,index) in rows" :key="index">
                        <td>
                          <div class="checkbox">
                            <label>
                              <input type="checkbox" v-model="selectedTable" :value="row.id" />
                            </label>
                          </div>
                        </td>
                        <td class="text-wrap">{{row.button_title}}</td>
                        <td>
                          <div class="user-add-shedule-list">
                            <a href="javascript:void(0)">{{row.button_text}}</a>
                          </div>
                        </td>
                        <td class="text-wrap">
                          <span>{{row.button_response}}</span>
                        </td>

                        <td>
                          <div class="dropdown action-label">
                            <a
                              class="btn btn-white btn-sm btn-rounded dropdown-toggle"
                              href="#"
                              data-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <i class="fa fa-dot-circle-o text-danger"></i> Options
                            </a>
                            <div class="dropdown-menu dropdown-menu-right">
                              <a @click.prevent="detailData(row.id)" class="dropdown-item">
                                <i class="fa fa-pencil text-success"></i> Edit
                              </a>
                              <a @click.prevent="deleteData(row.id)" class="dropdown-item">
                                <i class="fa fa-trash-o text-danger"></i> Remove
                              </a>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </template>
                    <template v-else-if="rows.length<1 && !loading">
                      <tr>
                        <td colspan="5" class="text-center">-empty-</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-6">
              <span class="footer__row-count__label">Displaying</span>
              <select
                @change="onPerPageChange(serverParams.perPage)"
                autocomplete="off"
                name="perPageSelect"
                v-model="serverParams.perPage"
                style="width: 100px;"
                class="select-to-paginasi"
              >
                <option value="10">10 / page</option>
                <option value="20">20 / page</option>
                <option value="30">30 / page</option>
                <option value="40">40 / page</option>
                <option value="50">50 / page</option>
              </select>
              <span class="footer__row-count__label">of {{ totalRecords }} total records</span>
            </div>
            <div class="col-sm-12 col-md-6 text-right">
              <a
                href="javascript:void(0)"
                @click="onPrevChange(parseInt(currentPage))"
                tabindex="0"
                class="btn"
                :class="{ disabled: parseInt(currentPage) - 1 <= 0 }"
              >
                <span class="chevron left"></span>
                <span>Prev</span>
              </a>
              page
              <input
                style="width:100px;"
                min="1"
                type="number"
                v-model="currentPage"
                @keyup.enter="onPageChange(parseInt(currentPage))"
                class
              />
              of {{ Math.ceil(totalRecords / serverParams.perPage) }}
              <a
                href="javascript:void(0)"
                @click="onNextChange(parseInt(currentPage))"
                tabindex="0"
                class="footer__navigation__page-btn"
                :class="'btn '+{
                    disabled:
                      parseInt(currentPage) + 1 >
                      Math.ceil(totalRecords / serverParams.perPage)
                  }"
              >
                <span>Next</span>
                <span class="chevron right"></span>
              </a>
            </div>
          </div>
        </div>
        <!-- /Page Content -->
      </div>
      <!-- /Page Wrapper -->
    </div>

    <form-data :searchData="searchData" />

    <!-- {{selectedContact}} -->
  </div>
</template>

<script>
import {
  currentDateTimeUnix,
  formatLocalDate,
  nFormatter,
  getCurrentMonth,
  formatDate,
  labelStatusMessage,
  formatLocalDateWithDay,
  getWhatsappNumberFromJid
} from "@/utils/helper";
import { Skeleton } from "vue-loading-skeleton";
import FormData from "./form.vue";
import Multiselect from "vue-multiselect";
require("vue-multiselect/dist/vue-multiselect.min.css");

import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Skeleton,
    Multiselect,
    FormData
  },
  data() {
    return {
      selectedTable: [],
      isLoading: false,
      isShowModal: false,
      loading: false,
      rows: [],
      totalRecords: 0,
      currentPage: 1,
      rowPage: 1,
      serverParams: {
        columnFilters: {
          button_title: "",
          button_text: "",
          button_response: ""
        },
        page: 1,
        perPage: 20 // perPage
      }
    };
    //  isactive : true
  },
  watch: {},
  computed: {
    selectAllTable: {
      get: function() {
        return this.rows
          ? this.selectedTable.length == this.rows.length
          : false;
      },
      set: function(value) {
        var selectedTable = [];

        if (value) {
          this.rows.forEach(function(row) {
            selectedTable.push(row.id);
          });
        }

        this.selectedTable = selectedTable;
      }
    }
  },
  created() {
    this.loadItems();
    this.currentPage = this.serverParams.page;
  },
  methods: {
    hideActions() {
      this.selectAllTable = false;
      this.selectedTable = [];
    },
    actionDelete() {
      if (this.selectedTable.length == 0) {
        this.$fire({
          title: "Error",
          text: "Please select at least one data",
          type: "error",
          timer: 2000
        });
        return;
      }
      this.isLoading = true;
      this.$fire({
        title:
          "Are you sure you want to permanently erase " +
          this.selectedTable.length +
          " messages?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      })
        .then(async r => {
          if (r.value == true) {
            let newParam = {
              id: this.selectedTable
            };
            this.$store
              .dispatch("automation/actionDeleteAutoReplyButton", newParam)
              .then(response => {
                this.$fire({
                  title: "Success Delete",
                  text: "The data was successfully deleted",
                  type: "success",
                  timer: 2000
                });
                this.isLoading = false;
                this.selectedTable = [];
                this.selectAllTable = false;

                this.searchData();
              })
              .catch(e => {
                this.isLoading = false;
              });
          } else {
            this.isLoading = false;
          }
        })
        .catch(e => {
          this.isLoading = false;
        });
    },
    async detailData(id) {
      //set false dulu
      this.$store.dispatch("automation/setIsShowForm", false);

      let dataParam = await {};
      dataParam = await {
        id: id
      };
      let formData = await {};
      await this.$store
        .dispatch("automation/detailReplyButtons", dataParam) // sesuai kan dengan method di API
        .then(response => {
          var { data } = response;
          formData = data;
        });
      // console.log(formData);
      formData.id = id;
      await this.$store.dispatch("automation/actFormParamSt", formData);
      // this.showBroadcast();
      var elem = this.$refs.formBcEdit;
      elem.click();
    },
    deleteData(id) {
      this.$fire({
        title: "Are you sure you will continue this action?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {
        if (typeof r.value != "undefined" && r.value == true) {
          let dataParam = {};
          dataParam = {
            id: id
          };
          this.$store
            .dispatch("automation/deleteReplyButtons", dataParam) // sesuai kan dengan method di API
            .then(response => {
              this.searchData();
              this.$fire({
                title: "Success",
                text: response["msg"],
                type: "success",
                timer: 2000
              });
            });
        }
      });
    },

    showBroadcast(newData) {
      if (typeof newData != "undefined" && newData == true) {
        this.$store.dispatch("automation/setIsShowForm", false);

        let formData = {
          id: "",
          button_title: "",
          button_text: "",
          button_response: ""
        };
        this.$store.dispatch("automation/actFormParamSt", formData);
      }
      var that = this;
      setTimeout(function() {
        var liContainer = document.getElementById("add_form");
        var isShowModal = liContainer.classList.contains("show");
        // console.log("isShowModal", isShowModal);
        // this.$root.$emit("infiniteHandlerContact");
        if (isShowModal == true) {
          that.$store.dispatch("automation/setIsShowForm", true);
        }
      }, 1000);
    },

    updateParams(newProps) {
      // console.log("newprops", newProps);
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    async onPageChange(page) {
      await this.updateParams({ page: page });
      this.currentPage = page;
      await this.loadItems();
    },
    async onNextChange(page) {
      if (
        page + 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page + 1 });
        this.currentPage = page + 1;
        await this.loadItems();
      }
    },
    async onPrevChange(page) {
      // console.log("this.currentPage:: ", this.currentPage);
      if (this.currentPage == 1) {
        return;
      }
      if (
        page - 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page - 1 });
        this.currentPage = page - 1;
        await this.loadItems();
      }
    },
    async onPerPageChange(params) {
      await this.updateParams({
        page: this.currentPage,
        perPage: this.serverParams.perPage
      });
      await this.loadItems();
    },
    formatDate(value) {
      return formatDate(value);
    },
    getCurrentMonth() {
      return getCurrentMonth();
    },
    nFormatter(value) {
      return nFormatter(value);
    },
    async searchData() {
      // this.currentPage = await 1;
      // this.serverParams.columnFilters.page = await 1;
      // await this.getListData();

      this.currentPage = 1;
      this.rows = await [];
      this.loading = await true;
      this.totalRecords = await 0;
      var params = await { page: this.currentPage };
      await this.updateParams(params);
      await this.loadItems();
      this.loading = await false;
    },
    async loadItems() {
      this.loading = await true;
      this.serverParams.page =
        this.serverParams.page - 1 <= 0
          ? await 0
          : await ((this.serverParams.page - 1) * this.serverParams.perPage);

      await this.$store
        .dispatch("automation/listReplyButtons", this.serverParams) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          this.totalRecords = data.totalRecords;
          this.rowPage = data.page;
          this.rows = data.data;
          // console.log("rows", this.rows);
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  mounted() {
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "broadcast-list"
};
</script>


// WEBPACK FOOTER //
// src/views/automation/replyButtons/list.vue